import OpenSansSemiBoldText from './OpenSansSemiBoldText';

export default OpenSansSemiBoldText;
